import styled from 'styled-components';

import Text from '~/components/Text';

// eslint-disable-next-line import/prefer-default-export
export const ErrorMessage = styled(Text)`
  margin-top: 10px;
`;
